import { createActionHelpers } from 'vuex-loading';

const { startLoading, endLoading } = createActionHelpers({
    moduleName: 'loading',
});

const state = {
    supplier: {
        name: null,
        address: null,
        postal_code: null,
        city: null,
        country: { name: 'Malaysia' },
        state: { name: 'Selangor' },
        contact_name: null,
        contact_email: null,
        contact_no: null,
        contact_fax: null,
        type: {
            id: 'S',
            name: 'Supplier',
        },
        status: {
            id: 1,
            name: 'Active',
        },
    },

    supplierList: [],
    countries: [],
};

const getters = {
    supplier: state => state.supplier,

    supplierList: state => state.supplierList,

    countries: state => state.countries,
};

const mutations = {
    setSupplier(state, data) {
        state.supplier = data;
    },

    setSupplierList(state, data) {
        state.supplierList = data;
    },

    clear(state) {
        state.supplier = {
            name: null,
            address: null,
            postal_code: null,
            city: null,
            contact_name: null,
            contact_email: null,
            contact_no: null,
            contact_fax: null,
            type: {
                id: 'S',
                name: 'Supplier',
            },
            status: {
                id: 1,
                name: 'Active',
            },
            country: { name: 'Malaysia' },
            state: { name: 'Selangor' },
        };
    },

    setCountries(state, data) {
        state.countries = data;
    },
};

const actions = {
    async getSupplierList({ commit, dispatch }, params = {}) {
        const url = Laroute.route('inventory.fnb.supplier.list');

        startLoading(dispatch, 'fetch-suppliers');

        const options = {
            params: Object.assign(
                {
                    query: '',
                    limit: 15,
                },
                params,
            ),
        };

        try {
            const { data } = await axios.get(url, options);
            commit('setSupplierList', data.data);
            endLoading(dispatch, 'fetch-suppliers');

            return data.data;
        } catch (e) {
            endLoading(dispatch, 'fetch-suppliers');
            throw e;
        }
    },

    async show({ commit, dispatch }, id) {
        const url = Laroute.route('inventory.fnb.supplier.show', { id });

        startLoading(dispatch, 'show-supplier');

        try {
            const { data } = await axios.get(url);
            endLoading(dispatch, 'show-supplier');

            let supplier = data;

            supplier.status = {
                id: data.status,
                name: data.status === false ? 'Inactive' : 'Active',
            };

            supplier.type = {
                id: data.type,
                name: data.type === 'S' ? 'Supplier' : 'Distributor',
            };

            if (!data.state) {
                if (data.country.name == 'Malaysia') {
                    supplier.state = {
                        name: 'Selangor',
                    };
                } else {
                    supplier.state = {
                        name: null,
                    };
                }
            }

            commit('setSupplier', supplier);

            return data;
        } catch (e) {
            endLoading(dispatch, 'show-supplier');
            throw e;
        }
    },

    async create({ commit, dispatch, state }, id) {
        const url = Laroute.route('inventory.fnb.supplier.create');

        startLoading(dispatch, 'save-supplier');

        let payload = state.supplier;
        payload.outlet_id = id;

        try {
            await axios.post(url, payload);
            endLoading(dispatch, 'save-supplier');
            commit('clear');
        } catch (e) {
            endLoading(dispatch, 'save-supplier');
            throw e;
        }
    },

    async update({ dispatch, state }) {
        const url = Laroute.route('inventory.fnb.supplier.update');

        startLoading(dispatch, 'save-supplier');

        try {
            await axios.put(url, state.supplier);
            endLoading(dispatch, 'save-supplier');
        } catch (e) {
            endLoading(dispatch, 'save-supplier');
            throw e;
        }
    },

    async getCountries({ dispatch, commit }) {
        const url = Laroute.route('inventory.fnb.supplier.country.list');

        startLoading(dispatch, 'country-supplier');

        try {
            const { data } = await axios.get(url, state.countries);
            commit('setCountries', data);
            endLoading(dispatch, 'country-supplier');
        } catch (e) {
            endLoading(dispatch, 'country-supplier');
            throw e;
        }
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};



// WEBPACK FOOTER //
// ./resources/assets/js/store/inventory-fnb/modules/supplier.js